<template>
  <div class="container" ref="tree">
    <div id="sidenav" class="active" v-if="sidenav">
      <div class="sticky-header" style="border: 0;">
       <p class="over-heard-title">
      <img :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'" src="../../assets/img/aixueji1.png" alt="" /></p>
    <a href="javascript:;"  @click="sidenav=false" class="close"><img src="../../assets/img/sidenav_close.png"></a>
    </div>
    <div class="nav-box">
        <a @click="scrollClick(1)" :class="scroll<158?'otherClass':''">首页</a>
        <a  @click="scrollClick(2)" :class="scroll>158&&scroll<739?'otherClass':''"  class="active">产品优势</a>
        <a @click="scrollClick(3)" :class="scroll>739&&scroll<1277?'otherClass':''"  >产品方案</a>
        <a  @click="scrollClick(4)"  :class="scroll>1277&&scroll<2148?'otherClass':''">服务保障</a>
        <a @click="scrollClick(5)"  :class="scroll>2148&&scroll<2763?'otherClass':''">角色管理</a>
        <a @click="scrollClick(6)" :class="scroll>2763&&scroll<3134?'otherClass':''">合作案例</a>
        <a @click="scrollClick(7)"  :class="scroll>3134?'otherClass':''">关于我们</a>
         <a @click="freeTrail">免费体验</a>
          <a @click="loginIPhone">登录</a>
    </div>
    <a class="tel" href="tel:18130031564">咨询：18130031564</a>
</div>




    <div class="callUs"  @mouseleave="callUsValue=0">
     <div class="showQu" 
      :class="callUsValue==1?'inherits':'hiddens'"
       :id="callUsValue==1?'inherits':'hiddens'">
       <div   :style="clientWidth>1200?'color: #504F5B;font-size: 16px;position: relative;top: 9px;':'color: #504F5B;font-size:1rem;position: relative;top:3px;'">扫码加好友联系客服</div>
       <div class="mainQu">
         <div>
            <img class="qurshowcode" src="../../assets/img/limg.png" alt="" /> 
           <div class="show-name">客服小智</div>
         </div>
          <div>
            <img class="qurshowcode" src="../../assets/img/yimg.png" alt="" /> 
           <div class="show-name">咨询顾问小叶</div>
         </div>
       </div>
       <div>

       </div>
     </div>

      <div class="callus" @mouseenter="callUsValue=1">
        <img src="../../assets/img/messing.png" alt="">
        <p>联系我们</p>
         </div>
    </div>
    <img @click="scrollClick(1)" v-if="scroll>3800" class="back_to_top" src="../../assets/img/back_to_top.png" alt="">
    <div class="container-header">
      <div class="sticky-header" :style="scroll<69?'display:none':''">
        <p class="over-heard-title">
          <img :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'"  src="../../assets/img/aixueji1.png" alt="" />  
        </p> 
         <div class="sticky-heard-tab" style="color:#444444">
          <span @click="scrollClick(1)" :class="scroll<474?'otherClass':''">首页</span>
          <span @click="scrollClick(2)" :class="scroll>474&&scroll<1191?'otherClass':''">产品优势</span>
          <span  @click="scrollClick(3)" :class="scroll>1191&&scroll<1797?'otherClass':''">产品方案</span>
           <span @click="scrollClick(4)"  :class="scroll>1797&&scroll<2518?'otherClass':''">服务保障</span>
          <span @click="scrollClick(5)"  :class="scroll>2518&&scroll<3198?'otherClass':''">角色管理</span>
          <span  @click="scrollClick(6)" :class="scroll>3198&&scroll<3614?'otherClass':''">合作案例</span>
          <span @click="scrollClick(7)"  :class="scroll>3614?'otherClass':''">关于我们</span>
         
          <span @click="login" class="loginbtn">登录</span>              
        </div>
        <a  @click="sidenav=true" class="menu mobile"> </a>
      </div>       
    
      <el-carousel :class="clientWidth>1200?'carousel':'carousels'" :height="clientWidth>1200?'800px':'210px'"
          :style="clientWidth>1200?'height: 800px;position: relative;width: 100%;background:#d69380':'overflow: hidden;height:210px;position: relative;width: 100%;background:#d69380'" direction="vertical" :autoplay="true">
    <el-carousel-item v-for="(item,index) in list" :key="index">      
        <img v-if="clientWidth>1200" style="height: 800px;width: 100%;object-fit: cover;" :src="item.img" alt="">   
         <img v-else style="height:210px; width: 100%;object-fit: cover;" :src="item.imgs" alt="">     
    </el-carousel-item>
       

      <div class="over-heard">
        <p class="over-heard-title">
          <img  :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'"  src="../../assets/img/aixueji.png" alt="" />  
        </p>
        <div class="over-heard-tab">
          <span @click="scrollClick(1)">首页</span>
          <span @click="scrollClick(2)">产品优势</span>
          <span @click="scrollClick(3)">产品方案</span>
            <span @click="scrollClick(4)">服务保障</span>
          <span @click="scrollClick(5)">角色管理</span>
          <span @click="scrollClick(6)">合作案例</span>
          <span @click="scrollClick(7)">关于我们</span>          
          <span class="login"  @click="login">登录</span>              
        </div>
        <a    @click="sidenav=true" class="menu-show mobile"> </a>
      </div>
     <div :class="clientWidth<1600?'main-pages':clientWidth<1511?'main-page2':'main-page'">        
     <button class="free-btn" @click="freeTrail">免费体验</button>                
      </div>
        <svg  class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
                <defs>                 
                    <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>                    
                </defs>
                <g class="parallax">                  
                    <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7"></use>
                    <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)"></use>
                    <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)"></use>
                    <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff"></use>                
                </g>               
            </svg> 
              </el-carousel>
             

     
      
       

       
            

    </div>  


<!-- 2.我们的产品优势 -->
 	
        <div class="sectionthree">
      <div class="section">
        <div class="section-top">
          <h2>产品优势</h2>
          <div class="sm-title">专注团学 专业二课 专心服务</div>
        </div>       
      </div>
        <div class="sectionthree-main" :style="clientWidth>1200?'':'display: flex;flex-wrap: wrap;width: 95%;padding:1.3rem 0 40px;'">
          <div class="sectionthree-nav showNavleft"  @mouseenter="enter(0)" @mouseleave="leave(0)">
            <img class="sectionthree-img" src="../../assets/img/index_produc_ico1.png" alt="" /> 
            <p>整体化解决方案</p>
            <p>基于高校团委以第二课堂成绩单体系建设为契机，构建本校智慧团学事务一站式服务大数据平台</p>
            <div class="sectionthree-nav-line"></div>
          </div>
          <div class="sectionthree-nav showNavleft"  @mouseenter="enter(1)" @mouseleave="leave(1)">
            <img class="sectionthree-img" src="../../assets/img/index_produc_ico2.png" alt="" /> 
            <p>支持高校自主研发</p>
            <p>以高校团委一站式服务大数据平台研发为顶层规划，包含第二课堂成绩单核心功能，新增团委个性化功能定制开发</p>
             <div class="sectionthree-nav-line"></div>
          </div>
         <div class="sectionthree-nav showNavRight"  @mouseenter="enter(2)" @mouseleave="leave(2)">
           <img class="sectionthree-img" src="../../assets/img/index_produc_ico3.png" alt="" /> 
            <p>本地化部署安全可靠</p>
            <p>主推本地化私有云部署，依据学校信息化标准、技术规范要求、真正做到安全可靠数据保障</p>
             <div class="sectionthree-nav-line"></div>
          </div>
          <div class="sectionthree-nav showNavRight"  @mouseenter="enter(3)" @mouseleave="leave(3)">
            <img class="sectionthree-img" src="../../assets/img/index_produc_ico4.png" alt="" />
            <p>平台数据互联互通</p>
            <p>支持与易班、校内系统数据对接，形成多平台数据互联互通，持续促进高校校内教育资源的融合与完善，实现高校教育资源整合向纵深化发展</p>
             <div class="sectionthree-nav-line"></div>
          </div>
        </div>          
    </div>
   






<!-- 3.产品方案 -->
     <div class="sectionthree" id="projectCase" :style="clientWidth>1200?'':'padding:0rem 0 2rem;'">
      <div class="section">
        <div class="section-top" :style="clientWidth>1200?'':'padding: 1.2rem 0 1.1rem;'">
          <h2>产品方案</h2>
          <div class="sm-title">提供智慧团学（第二课堂）整体解决方案</div>          
        </div>         
      </div>
      <div style="display: flex;justify-content: center;">
      <div class="pro-container">
       <div class="proLeft">
          <p  @click="procaseClick(1)" :class="caseVale==1?'leftBut':'leftLine'"><img class="pro-img" src="../../assets/img/pro_solu_tag1.png" alt="" /> 课程活动</p>
          <p  @click="procaseClick(2)" :class="caseVale==2?'leftBut':'leftLine'"><img class="pro-img" src="../../assets/img/pro_solu_tag2.png" alt="" /> 校园组织</p>
          <p  @click="procaseClick(3)" :class="caseVale==3?'leftBut':'leftLine'"><img class="pro-img" src="../../assets/img/pro_solu_tag3.png" alt="" /> 线上审核</p>
          <p  @click="procaseClick(4)" :class="caseVale==4?'leftBut':'leftLine'"><img class="pro-img" src="../../assets/img/pro_solu_tag4.png" alt="" /> 人物画像</p>
          <p  @click="procaseClick(5)" :class="caseVale==5?'leftBut':'leftLine'"><img class="pro-img" src="../../assets/img/pro_solu_tag5.png" alt="" /> 成绩单</p>
       </div>       
        <div class="proRight" v-show="caseVale==1">
           <p>课程活动</p>
           <p>构建第二课堂活动体系，实现活动创建、活动审批、报名签到的流程化管理，开拓学生视野，丰富知识，增长智慧，激发兴趣，培养学生创新精神和实践能力；</p>
            <div>
               <button class="probut" @click="scrollClick(8)" >免费咨询</button>
            </div>
         </div>
         </div>
          <div class="proRight" v-show="caseVale==2">
           <p>校园组织</p>
           <p>智慧团学深度契合高校办学特色和人才培养实际目标完善学生组织运行机制，实现组织纳新、换届、注册、评优、年审的信息化管理，线上组织便捷管理;</p>
            <div>
             <button class="probut" @click="scrollClick(8)" >免费咨询</button>
            </div>
         </div>
         <div class="proRight" v-show="caseVale==3">
           <p>线上审核</p>
           <p>系统提供全流程线上操作，一键上传所有资料，手续简便，实时线上快速审核，告别传统审核模式，便于用户操作流程和使用，简化了过程中的一系列操作；</p>
            <div>
              <button class="probut" @click="scrollClick(8)" >免费咨询</button>
            </div>
         </div>
          <div class="proRight" v-show="caseVale==4">
           <p>人物画像</p>
           <p>提升大学生综合素质，实现第二课堂成绩单客观记录、科学评价、促进成长、融入社会的过程化管理，学生各项信息数据统计分析，实现学生模型维度画像。</p>
            <div>
                <button class="probut" @click="scrollClick(8)" >免费咨询</button>
            </div>
         </div>
          <div class="proRight" v-show="caseVale==5">
           <p>成绩单</p>
           <p> 通过工作内容、项目供给、评价机制等方面系统构建高校第二课堂成绩单管理平台，客观记录、认证学生参与“第二课堂”活动的经历和成果</p>
            <div>
               <button class="probut" @click="scrollClick(8)" >免费咨询</button>
            </div>
         </div>
      </div>

       
    </div> 












<!-- 
    “八个一”服务保障 -->
        <div class="sectionthree" :style="clientWidth>1200?'padding-bottom: 8rem;padding-top: 3rem;':'padding-bottom:3rem;padding-top: 3rem'">
      <div class="section">
        <div class="section-top" style="position: relative;bottom:2rem;">
          <h2>“八个一”服务保障</h2>
          <div class="sm-title">全流程无忧 顾问式服务</div>
        </div>       
      </div>
        <div class="sectionthree-main" v-if="clientWidth>1200">
         
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们开创“一站式服务”和“一对一顾问式服务”，并打造“一校一品”。全程协助高
                校从 0 到 1，从顶层方案规划、个性化平台开发、师生全面推广使用、全天候的跟踪服务。</p>
              </div>
              <span>  <img src="../../assets/img/servi_ens_ic1.png" alt="" /></span>
              <div>1站式整体解决方案</div>
            </div>
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们拥有全国百所以上高校建设成功案例，不同层次、不同类型、不同地区等高校。</p>
              </div>
            <span>  <img src="../../assets/img/servi_ens_ic2.png" alt="" /></span>
              <div>100所+高校成功案例</div>
            </div>
            <div class="serviceguarantee">
               <div class="color-layer">
                 <p>我们做到行业内平台使用最快水准，平台从高校要求到到正式使用，我们一天内完成开
                 通、搭建、数据初始化等全部工作。</p>
               </div>
             <span>  <img src="../../assets/img/servi_ens_ic3.png" alt="" /></span>
              <div>1周内完成平台真正使用</div>
            </div>
             </div>  
              <div class="sectionthree-main" v-if="clientWidth>1200">
         
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>1小时内师生在线咨询客服，我们承诺线下4小时内上门服务。</p>
              </div>
               <span>  <img src="../../assets/img/servi_ens_ic4.png" alt="" /></span>
              <div>1小时内师生在线客服</div>
            </div>
            <div  v-if="clientWidth>1200"   style="width:384px;margin: 15px;">
              <img src="../../assets/img/service.png" alt="" />
            </div>
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们平台已经突破百万级用户数量，多家服务高校累计活动报名人次突破百万、多家服
                   务高校单日平台报名量突破 1 万+人次。</p>
              </div>
               <span>  <img src="../../assets/img/servi_ens_ic5.png" alt="" /></span>
              <div>100万+师生用户量</div>
            </div>
             </div>  
              <div class="sectionthree-main" v-if="clientWidth>1200">
         
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们移动端接入团委微信公众号，并承诺与教务、学工、智慧校园及易班 APP 等平台实
                 现多端口无缝对接、完成统一身份认证。</p>
              </div>
              <span>  <img src="../../assets/img/servi_ens_ic6.png" alt="" /></span>
              <div>1+N移动端入口</div>
            </div>
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们实时动态输出高校第二课堂成绩单大数据，通过信息中心库对学生第二课堂学分数
                据实时回传教务、学工系统，实现数据互联互通。</p>
              </div>
              <span>  <img src="../../assets/img/servi_ens_ic7.png" alt="" /></span>
              <div>1体化大数据中心</div>
            </div>
            <div class="serviceguarantee">
              <div class="color-layer">                 
                <p>我们坚持提供更好产品、更优服务、更深情怀的用户优先理念，智慧团学平台每周定期优化升级。</p>
              </div>
               <span>  <img src="../../assets/img/servi_ens_ic8.png" alt="" /></span>
              <div>1周定期平台优化升级</div>
            </div>
             </div>  

             <div  class="sectionthree-main" v-if="clientWidth<1200" style="width: 95%;display: flex;flex-wrap: wrap;position: relative;bottom: 1%;">
                 
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们开创“一站式服务”和“一对一顾问式服务”，并打造“一校一品”。全程协助高
                校从 0 到 1，从顶层方案规划、个性化平台开发、师生全面推广使用、全天候的跟踪服务。</p>
              </div>
              <span>  <img src="../../assets/img/servi_ens_ic1.png" alt="" /></span>
              <div>1站式整体解决方案</div>
            </div>
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们拥有全国百所以上高校建设成功案例，不同层次、不同类型、不同地区等高校。</p>
              </div>
            <span>  <img src="../../assets/img/servi_ens_ic2.png" alt="" /></span>
              <div>100所+高校成功案例</div>
            </div>
            <div class="serviceguarantee">
               <div class="color-layer">
                 <p>我们做到行业内平台使用最快水准，平台从高校要求到到正式使用，我们一天内完成开
                 通、搭建、数据初始化等全部工作。</p>
               </div>
             <span>  <img src="../../assets/img/servi_ens_ic3.png" alt="" /></span>
              <div>1周内完成平台真正使用</div>
            </div>
             <div class="serviceguarantee">
              <div class="color-layer">
                <p>1小时内师生在线咨询客服，我们承诺线下4小时内上门服务。</p>
              </div>
               <span>  <img src="../../assets/img/servi_ens_ic4.png" alt="" /></span>
              <div>1小时内师生在线客服</div>
            </div>            
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们平台已经突破百万级用户数量，多家服务高校累计活动报名人次突破百万、多家服
                   务高校单日平台报名量突破 1 万+人次。</p>
              </div>
               <span>  <img src="../../assets/img/servi_ens_ic5.png" alt="" /></span>
              <div>100万+师生用户量</div>
            </div>
             <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们移动端接入团委微信公众号，并承诺与教务、学工、智慧校园及易班 APP 等平台实
                 现多端口无缝对接、完成统一身份认证。</p>
              </div>
              <span>  <img src="../../assets/img/servi_ens_ic6.png" alt="" /></span>
              <div>1+N移动端入口</div>
            </div>
            <div class="serviceguarantee">
              <div class="color-layer">
                <p>我们实时动态输出高校第二课堂成绩单大数据，通过信息中心库对学生第二课堂学分数
                据实时回传教务、学工系统，实现数据互联互通。</p>
              </div>
              <span>  <img src="../../assets/img/servi_ens_ic7.png" alt="" /></span>
              <div>1体化大数据中心</div>
            </div>
            <div class="serviceguarantee">
              <div class="color-layer">                 
                <p>我们坚持提供更好产品、更优服务、更深情怀的用户优先理念，智慧团学平台每周定期优化升级。</p>
              </div>
               <span>  <img src="../../assets/img/servi_ens_ic8.png" alt="" /></span>
              <div>1周定期平台优化升级</div>
            </div>




             </div>




             
               
    </div>

<!--4.产品各角色原理 -->
    
    
    
     <div class="sectionthree" style="background: #f7f7f9;" :style="clientWidth>1200?'':'padding: 1.2rem 0 2.5rem;'">
      <div class="section">
        <div class="section-top">
            <h2>产品各角色原理</h2>
          <div class="sm-title">平台多端入口 数据互联互通</div>          
        </div>         
      </div>

        <div class="sectionthree-main" :style="clientWidth>1200?'':'display: flex;flex-wrap: wrap;width: 95%;padding-top:1.2rem;'">
          <div :class="scroll<820?'':'sectionthree-role showNavleft'"   >            
            <p>
             <img class="sectionthree-img1" src="../../assets/img/pro_role_def1.png" alt="" />
            <img class="sectionthree-img2" src="../../assets/img/pro_role_sli1.png" alt="" />
            </p>
            <h4>第二课堂管理系统</h4>
            <p>协同育人</p>
            <p>数据传输</p>
            <p>执行数据反馈</p>
            <p>综合能力报告</p>
          </div>
          <div :class="scroll<820?'':'sectionthree-role showNavleft'" >            
            <p><img class="sectionthree-img1" src="../../assets/img/pro_role_def2.png" alt="" />
             <img class="sectionthree-img2" src="../../assets/img/pro_role_sel2.png" alt="" />
            </p>
            <h4>团学组织单位</h4>
            <p>开课计划</p>
            <p>活力值评估</p>
            <p>组织开课</p>
          </div>
         <div  :class="scroll<820?'':'sectionthree-role showNavRight'" >            
            <p><img class="sectionthree-img1" src="../../assets/img/pro_role_def3.png" alt="" />
             <img class="sectionthree-img2" src="../../assets/img/pro_role_sel3.png" alt="" />
            </p>
             <h4>教务部门</h4>
            <p>精准匹配</p>
            <p>获得成绩认证</p>
            <p>课程优化方案</p>
          </div>
          <div :class="scroll<820?'':'sectionthree-role showNavRight'">             
            <p><img class="sectionthree-img1" src="../../assets/img/pro_role_def4.png" alt="" />
             <img class="sectionthree-img2" src="../../assets/img/pro_role_sel4.png" alt="" />
            </p>
             <h4>学生家庭社会</h4>
            <p>参与课程</p>
            <p>自由选课获得学分</p>
            <p>修满学分综合素质评价</p>
          </div>
        </div>          
    </div> 
    

<!-- 5.部分高校合作案例 -->

<div class="sectionthree" :style="clientWidth>1200?'':'padding: 2rem 0 3rem;'">
      <div class="section">
        <div class="section-top">
            <h2>部分高校合作案例</h2>
          <div class="sm-title"> 客户第一  拥抱变化  全力以赴</div>         
        </div>        
      </div>
       <img  style="object-fit: contain;width: 100%;position: relative;top: 1.2rem;" v-if="clientWidth<1200" src="../../assets/img/allschool.png" alt="" /> 

      <div v-if="clientWidth>1200" class="cooperation">
       <!-- <span class="cooperation-circle left-icon">
         <i class="el-icon-arrow-left"></i>
       </span> -->
       <div class="cooperation-main"  >
         <div v-if="clientWidth>1200" @mouseenter="enterschLogo(1)" @mouseleave="leaveschLogo(0)" 
         :style="owlVal==2?'transform:translateX(-35%);':owlVal==3?'transform:translateX(-50%);':owlVal==4?'transform:translateX(-71%);':'transform:translateX(0)'"
          :class="schVal==1?'cooperation-main-logoCover':'cooperation-main-logoBox'">
           <img src="../../assets/img/cop_sch_logo1.png" alt="" />   
           <img src="../../assets/img/cop_sch_logo2.png" alt="" />
           <img src="../../assets/img/cop_sch_logo3.png" alt="" />
           <img src="../../assets/img/cop_sch_logo4.png" alt="" />
           <img src="../../assets/img/cop_sch_logo5.png" alt="" /> 
            <img src="../../assets/img/cop_sch_logo6.png" alt="" />
           <img src="../../assets/img/cop_sch_logo7.png" alt="" />
           <img src="../../assets/img/cop_sch_logo8.png" alt="" />
           <img src="../../assets/img/cop_sch_logo9.png" alt="" />
           <img src="../../assets/img/cop_sch_logo10.png" alt="" /> 
           <img src="../../assets/img/cop_sch_logo11.png" alt="" />
           <img src="../../assets/img/cop_sch_logo12.png" alt="" />
           <img src="../../assets/img/cop_sch_logo13.png" alt="" />
           <img src="../../assets/img/cop_sch_logo14.png" alt="" /> 
           </div>
           <div v-if="clientWidth>1200"  @mouseenter="enterschLogo(1)" @mouseleave="leaveschLogo(0)" 
            :style="owlVal==2?'transform:translateX(-38%);':owlVal==3?'transform:translateX(-53.5%);':owlVal==4?'transform:translateX(-69%);':'transform:translateX(0)'"
            :class="schVal==1?'cooperation-main-logoCover':'cooperation-main-logoBox'">
           <img src="../../assets/img/cop_sch_logo15.png" alt="" />
           <img src="../../assets/img/cop_sch_logo16.png" alt="" />
           <img src="../../assets/img/cop_sch_logo17.png" alt="" />
           <img src="../../assets/img/cop_sch_logo18.png" alt="" />
           <img src="../../assets/img/cop_sch_logo19.png" alt="" /> 
            <img src="../../assets/img/cop_sch_logo20.png" alt="" />
           <!-- <img src="../../assets/img/cop_sch_logo21.png" alt="" /> -->
           <img src="../../assets/img/cop_sch_logo22.png" alt="" />
           <img src="../../assets/img/cop_sch_logo23.png" alt="" />
           <img src="../../assets/img/cop_sch_logo24.png" alt="" /> 
           <img src="../../assets/img/cop_sch_logo25.png" alt="" />
           <img src="../../assets/img/cop_sch_logo26.png" alt="" />
           <img src="../../assets/img/cop_sch_logo27.png" alt="" />
           <img src="../../assets/img/cop_sch_logo28.png" alt="" /> 
           </div>
          
       </div>
       <!-- <span class="cooperation-circle right-icon">
        <i class="el-icon-arrow-right"></i>
       </span> -->
      </div>
      <div class="owl-dots " v-if="clientWidth>1200">
        <p @click="owlClick(1)" class="owl-dot" :class="owlVal==1?'owl-dob':''"></p>
        <p @click="owlClick(2)" class="owl-dot" :class="owlVal==2?'owl-dob':''"></p>
        <p @click="owlClick(3)" class="owl-dot" :class="owlVal==3?'owl-dob':''"></p>
         <p @click="owlClick(4)" class="owl-dot" :class="owlVal==4?'owl-dob':''"></p>
      </div>

    
    </div> 





    
<!-- 新增新闻动态 -->

<!-- <div class="sectionthree">
      <div class="section">
        <div class="section-top">
            <h2>新闻动态</h2>
          <div class="sm-title">实时动态追踪，掌握最新消息</div>         
        </div>        
      </div>

      <div class="newscontain">
      <span class="newscontain-circle left-icon"  :class="newsVal==1?'getItcheck':'nocheck'"  @click="newsVal=1">
         <i class="el-icon-arrow-left"></i>
       </span>  
       <div class="newscontain-main">
         <div :style="newsVal==2?'transform:translateX(-50%);':''" :class="schVal==1?'newscontain-main-logoCover':'newscontain-main-logoBox'">
            <div class="newsBox" v-for="(item,index) in newsList.slice(0, 6)" :key="index" >
               <div>
                 <img :src="item.img" alt="">
               </div>
               <div style="height: 96px;">
                 <div class="newstitle">{{item.newsTitle}}</div>
                 <div class="newsDetail">{{item.detail}}</div>
                 <div class="newsctime">{{item.ctime}}</div>
               </div>
            </div>                   
           </div>
           <div :style="newsVal==2?'transform:translateX(-50%);':''" :class="schVal==1?'newscontain-main-logoCover':'newscontain-main-logoBox'">
               <div class="newsBox" v-for="(item,index) in newsList.slice(6,12)" :key="index" >
               <div>
                 <img :src="item.img" alt="">
               </div>
               <div style="height: 96px;">
                 <div class="newstitle">{{item.newsTitle}}</div>
                 <div class="newsDetail">{{item.detail}}</div>
                 <div class="newsctime">{{item.ctime}}</div>
               </div>

            </div>
           </div>
       </div>
        <span  @click="newsVal=2"  :class="newsVal==2?'getItcheck':'nocheck'"  class="newscontain-circle right-icon">
        <i class="el-icon-arrow-right"></i>
       </span>  
      </div>      
    </div>  -->

<!-- 6.关于我们 -->

<div class="sectionthree" id="aboutUs">
      <div class="section" >
        <div class="section-top" :style="clientWidth>1200?'':'padding: 1.5rem 0 0.8rem;'">
           <h2>关于我们</h2>
          <div class="sm-title">成为社会尊重的教育科技公司</div>               
        </div>        
      </div>

      <div class="aboutUs">
        <div class="aboutUs-cover">
          <div class="aboutUs-top" style="position: relative;">           
          
            <p class="tagti1 tagimg1">分享</p>
             <p class="tagti1 tagimg2">坦诚</p>
              <p class="tagti1 tagimg3">勤俭 </p>
               <p class="tagti1 tagimg4">伙伴</p>
            <p style="z-index: 99;position: relative;">           
           <span class="aboutUs-top-message">安徽爱学记信息科技有限公司（简称：爱学记）</span>总部位于安徽合肥，荣获国家级高新技术企业。是一家聚合校、企、政、行、研等多方生态资源，以互联网+大数据、人工智能等新技术作支撑，构建协同育人一站式服务新模式。</p>
            <p style="z-index: 99;position: relative;">“智慧团学”是爱学记旗下自主研发运营的核心产品之一，基于高校团委以第二课堂成绩单体系建设为契机，构建本校的智慧团学事务一站式服务大数据平台，专注成为“高校团委第二课堂”整体化解决方案提供商，以“打造智慧团学平台，构建高校协同育人，赋能学生全面发展”为产品研发理念。产品获得多项国家软件著作权，获得国家公安部门的信息安全等级认定。</p>
           <p style="z-index: 99;position: relative;">公司创始团队和核心技术团队深耕教育行业15年以上，并拥有丰富的技术研发和实施经验。公司深耕教育领域，为校园构建“上游数据入口、中游技术开发、下游独立应用”的数据化运营管理闭环。公司以“服务教育、协同育人”为经营理念，以大数据、AI技术软硬件相结合，探索教育产业信息化现状及需求，不断研发客户满意的高质量产品，构建师生智慧协作的新场景、新生态、新未来。</p>
            <p style="z-index: 99;position: relative;">爱学记团队坚持提供更好产品、更优服务、更深情怀的用户优先理念，致力于赋能大学生全面发展。</p>
          </div>
          <div class="aboutUs-bottom">
            <div>
              <p class="leftitp">累计服务学校</p>
              <p class="leftitp"> 
                 <img src="../../assets/img/about_us1.png" alt="" />  
               <span>100+</span></p>
            </div>
            <div>
              <p class="leftitp">专业团队</p>
              <p class="leftitp"> 
                  <img src="../../assets/img/about_us4.png" alt="" />  
                <span>60+</span></p>
            </div>
            <div >
              <p class="leftitp">知识产权</p>
              <p class="leftitp"> 
                  <img src="../../assets/img/about_us3.png" alt="" />  
                <span>10+</span></p>
            </div>
            <div>
              <p class="leftitp">用户认可</p>
              <p class="leftitp"> 
               <img src="../../assets/img/about_us2.png" alt="" />  
                <span>100w+</span></p>
            </div>
          </div>
        </div>
      </div>

    
    </div> 

<!-- 7.联系我们 -->

<div class="sectionthree" id="contactUs">
      <div class="section">
        <div class="section-top" :style="clientWidth>1200?'':'padding: 2.5rem 0 1rem;'">
            <h2>联系我们</h2>
          <div class="sm-title">专注高校第二课堂成绩单建设，服务教育，协同育人</div>            
        </div>        
      </div>
      <div class="contactUs">
        <div class="contactUs-box">
        <!-- <div class="contactUs-title">爱学记联系服务中心</div> -->
        <div class="contactUs-tab">
          <div class="contactUs-line">
             <img src="../../assets/img/conta_phone.png" alt="" />  
            <div class="contactUs-line-message">
              <p>高校咨询</p>
              <p>唐老师:15955191028</p>
            </div>
          </div>
           <div class="contactUs-line" v-if="clientWidth>1200">
             
            <div class="contactUs-line-message">
              <p>商务合作</p>
              <p> <a  class="calltel" href="tel:18130031564">叶老师:18130031564</a></p>
            </div>
          </div>
           <div class="contactUs-line" v-if="clientWidth>1200">
              
            <div class="contactUs-line-message">
              <p>技术保障</p>
              <p>胡老师:13968033097</p>
            </div>
          </div>
           <div class="contactUs-line" v-if="clientWidth>1200" >
            
            <div class="contactUs-line-message">
              <p>售后处理</p>
              <p>李老师:18158850584</p>
            </div>
          </div>
        </div>
         <div class="contactUs-tab">
          <div class="contactUs-line">
             <img src="../../assets/img/conta_email.png" alt="" />  
            <div class="contactUs-line-message">
              <p>客服邮箱</p>
              <p>934034170@qq.com</p>
            </div>
          </div>
           </div>
            <div class="contactUs-tab">
          <div class="contactUs-line">
             <img src="../../assets/img/conta_address.png" alt="" />  
            <div class="contactUs-line-message">
              <p>总部地址</p>
              <p>合肥市高新区时代智谷创业园215室</p>
            </div>
          </div>
           </div>
           </div>


      </div>

    
    </div> 

<!-- 8.mi免费体验 -->
<div class="sectionthree" id="experie" style="height:160px;"> 
  <div style="display: flex;margin: 0 auto;
    align-items: center;width:1000px"> 
      <span class="sologin">我们始终坚持客户第一 为客户提供四大免费服务支持</span>
       <button id="button"  @click="freeTrail">免费体验</button>    
        </div> 
    </div> 
<!-- 9.底部联系方式 -->
<div class="sectionthree" id="otherBottom">
  <div class="otherBottom"> 
  <div class="otherBottom-top"> 
    <div>



         <img :style="clientWidth>1200?'':'width:23px;object-fit: contain;'" src="../../assets/img/footer_fun1.png" alt="" />  
         <span>免费提供建设方案</span>
    </div>
    <div>
         <img  :style="clientWidth>1200?'':'width:23px;object-fit: contain;'" src="../../assets/img/footer_fun1.png" alt="" />  
         <span>免费开通平台试用</span>
    </div>
    <div>
         <img  :style="clientWidth>1200?'':'width:23px;object-fit: contain;'" src="../../assets/img/footer_fun1.png" alt="" />  
         <span>免费搭建基础数据</span>
    </div>
    <div>
         <img  :style="clientWidth>1200?'':'width:23px;object-fit: contain;'" src="../../assets/img/footer_fun1.png" alt="" />  
         <span>免费上门软件培训</span>
    </div>

  </div>

  <div class="otherBottom-center">
   <div class="otherBottom-center-line lines">
     <div class="otherBottom-center-title">产品功能</div>
     <p @click="overClick(1)">课程活动</p>
     <p @click="overClick(2)">校园组织</p>
     <p @click="overClick(3)">线上审核</p>
     <p @click="overClick(4)">人物画像</p>
     <p @click="overClick(5)">成绩单</p>       
  </div>  
   <div class="otherBottom-center-line lines">
     <div class="otherBottom-center-title">合作品牌</div>
     <span>易班</span>
     <span>今日校园</span>     
     <span>企业微信</span>
     <span>钉钉</span>        
  </div>  
   <div class="otherBottom-center-line lines">
     <div class="otherBottom-center-title">关于我们</div>      
     <p  @click="scrollClick(7)">公司简介</p>
     <p @click="scrollClick(8)">联系我们</p>
       
  </div>  
   <div class="otherBottom-center-line">
     <p class="otherBottom-center-title"
      :style="clientWidth>1200?'':'padding-right: 51px'"> <img :style="clientWidth>1200?'':'width: 4rem;object-fit: cover;'"  src="../../assets/img/footer_logo.png" alt="" />  </p>
      <div>
        <img  class="qurshowcode" src="../../assets/img/foot_code1.png" alt="" /> 
        <img  class="qurshowcode"  style="position: relative;left: 15px;" src="../../assets/img/foot_code2.png" alt="" /> 
      </div>      
  </div>  
  </div> 
  </div>

   <div class="otherBottom-bottom">
     <span>Copyright © 安徽爱学记信息科技有限公司版权所有
      <br /><span @click="push" style="cursor: pointer;">备案号:皖ICP备19022735号-1</span></span>
   </div>       
    
    </div> 
  </div>
</template>
<script> 
 
export default {
  name: "Login",
  components:{    
       
    },
  data() {
    return {
      ifbox:false,
      caseVale:1,
      newsVal:1,
      owlVal:1,
      sidenav:false,
      callUsValue:'',
      clientWidth:'',
      list:[{img:require("@/assets/img/img1.jpg"),imgs:require("@/assets/img/imgs1.jpg")},
      {img:require("@/assets/img/img2.jpg"),imgs:require("@/assets/img/imgs2.jpg")},
      {img:require("@/assets/img/img3.jpg"),imgs:require("@/assets/img/imgs3.jpg")},            
      ],
      newsList:[
        {id:1,newsTitle:'浙江农林大学举办第二',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:2,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:3,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:4,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:5,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。',},
        {id:6,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},              
        {id:7,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:8,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:9,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:10,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:11,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
        {id:12,newsTitle:'浙江农林大学举办第二课堂系统培训会',img:require("@/assets/img/news1.png"),ctime:'2021-04-28 11:28',
        detail:'近日，浙江农林大学图书馆报告厅举办“第二课堂成绩单”制度解读及管理系统应用培训会，围绕“第二课堂成绩单”管理端、学生端系统进行操作培训，并针对2020级学生关心的问题进行了制度解读和现场答疑。'},
              
              
      ],
      TipsList:[],
      schVal:0,
      scroll:'',
    };
  },
  mounted(){
       this.clientWidth=document.body.clientWidth
    console.log(document.body.clientWidth,"schoolId");
      this.$refs.tree.addEventListener('scroll', e => {
        // console.log('父滚动条到页面顶部距离', e.target.offsetTop)
        console.log('相对距离', this.$refs.tree.scrollTop)
        this.scroll=this.$refs.tree.scrollTop*1
        // console.log('绝对距离', e.target.offsetTop + this.$refs.tree.scrollTop)
    }, false)
    //  this.fun()
  },
  methods: {
    push(){
      window.open( "http://beian.miit.gov.cn","_blank")
    },
    loginIPhone(){
     window.open( "https://win.9xueqi.com/#/","_blank")      
    },
    // owlStart(){
    //   this.owlVal++
    //   if(this.owlVal>4){
    //     this.owlVal=1
    //   }
    // },
    overClick(val){
      this.caseVale=val      
      if(this.clientWidth>1200){
       this.scroll=1192
       this.$refs.tree.scrollTop=1192     
      }else{
         this.scroll=740
       this.$refs.tree.scrollTop=740  
      }    
    },
    login(){
       window.open( "https://2kt.9xueqi.com/","_blank")        
    },
    freeTrail(){
        window.open(window.location.origin+'/#' + '/detail/')
    },
    scrollClick(val){
      this.sidenav=false
      if(this.clientWidth>1200){
       if(val==1){
       this.scroll=0
       this.$refs.tree.scrollTop=0
      }
      if(val==2){
       this.scroll=730
       this.$refs.tree.scrollTop=730
      }
       if(val==3){
       this.scroll=1192
       this.$refs.tree.scrollTop=1192
      }      
       if(val==4){
       this.scroll=1874
       this.$refs.tree.scrollTop=1874
      }


       if(val==5){
       this.scroll=2741
       this.$refs.tree.scrollTop=2741
      }
       if(val==6){
       this.scroll=3277
       this.$refs.tree.scrollTop=3277
      }
       if(val==7){
       this.scroll=3723
       this.$refs.tree.scrollTop=3723
      }
       if(val==8){
       this.scroll=4501
       this.$refs.tree.scrollTop=4501
      }
      }else{
         if(val==1){
       this.scroll=0
       this.$refs.tree.scrollTop=0
      }
      if(val==2){
       this.scroll=159
       this.$refs.tree.scrollTop=159
      }
       if(val==3){
       this.scroll=740
       this.$refs.tree.scrollTop=740
      }      
       if(val==4){
       this.scroll=1278
       this.$refs.tree.scrollTop=1278
      }


       if(val==5){
       this.scroll=2149
       this.$refs.tree.scrollTop=2149
      }
       if(val==6){
       this.scroll=2764
       this.$refs.tree.scrollTop=2764
      }
       if(val==7){
       this.scroll=3135
       this.$refs.tree.scrollTop=3135
      }
       if(val==8){
       this.scroll=4045
       this.$refs.tree.scrollTop=4045
      }

      }
    },
     scrollTop(){
       let container=document.getElementsByClassName('container')[0]
      this.scroll = container.scrollTop
      console.log(this.scroll,"距离高度的位置")
    },
    owlClick(val){
    this.owlVal=val     
    },
     fun(){
         setInterval(this.next,2000)
        },
    next(){
          this.owlVal++;
          if(this.owlVal == 4){
             this.owlVal = 1;
          }        
      },
    procaseClick(val){
      this.caseVale=val
    },   
    enterschLogo(val){
     this.schVal=val
    }, 
     leaveschLogo(val){
     this.schVal=val
    },
    enter(e){     
      let  line=document.getElementsByClassName('sectionthree-nav-line')[e]   
       line.style.width='100%'       

    },
     leave(e){
        let line=document.getElementsByClassName('sectionthree-nav-line')[e]   
         line.style.width='0px'    
    },
      toClient(id){
      this.$router.push({
        path: "/Client",
        query: { lesseeCompanyId: id }
      });
    },
    
    //点击地点显示对应位置数据
    boxPosition(){
      var e = event || window.event;
      var x=e.clientX+145+"px",
          y=e.clientY+5+"px";
      clearTimeout(t)
      var t = setTimeout(function (){
        $('#box').css('top',y),
        $('#box').css('left',x)
      }, 100);
      t
    },
       
  },
};
</script>
<style lang="scss">
#sidenav .tel {
    position: absolute;
    left: 50%;
    bottom: 1.875rem;
    width: 8.75rem;
    height: 1.875rem;
    line-height: 1.8125rem;
    margin-left: -4.375rem;
    font-size: 0.75rem;
    text-decoration: none;
    color: #1f294c;
    font-family: "syn";
    border: 0.03125rem solid #1f294c;
    border-radius: 0.15625rem;
}
#sidenav .close img {
    position: absolute;
    right: 1.0625rem;
    top: 1.4em;
    width: 0.75rem;
}
  .nav-box a {
    color: #444;
    text-decoration: none;
    margin-bottom: 1.8rem;
    font-size: 1.25rem;
}
#sidenav.active {
      z-index:99999;
    opacity: 1;
}
#sidenav {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color:white;
    z-index: -1;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    opacity: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-display: flex;
    -webkit-align-items: center;
    -webkit-justify-content: center;
}
#sidenav .nav-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    -webkit-display: flex;
    -webkit-align-items: center;
    -webkit-justify-content: center;
    -webkit-flex-direction: column;
}
@keyframes fadeInAnimation {
0% {
opacity: 0; /*设置不透明度*/
}
100% {
opacity: 1;
}
}

@keyframes fadeInshow {
0% {
 position:relative;
 top:100px;
}
100% {
 position:relative;
 top:0px;
}
}
@keyframes fadeInshowLeft {
0% {
 transform:translateX(-80%); 
}
100% {
transform:translateX(0); 
}
}
@keyframes fadeInshowRight {
0% {
 transform:translateX(80%); 
}
100% {
transform:translateX(0); 
}
}

@keyframes fadeInUp {
0% {
transform:translateY(70px); 
visibility:hidden;
}
100% {
transform:translateY(0);  
visibility:visible;
}
}
body {
animation: fadeInAnimation ease 3s;
animation-iteration-count: 1; /*设置动画播放次数*/
animation-fill-mode: forwards; /*设置样式以在动画不播放时应用元素。forward是设置动画结束后，使用元素的结束属性值*/

}

.Page{
  position: relative;
}
.sticky-header {
    position: fixed;
    // opacity: 0;
    // visibility: hidden;
    left: 0px;
    top: 0px;
    width: 100%;
    padding: 0px 0px;
    background: #ffffff;
    // z-index: 0;
    border-bottom: 1px solid #e8f1f7;
    transition: all 500ms ease;
    -moz-transition: all 500ms ease;
    -webkit-transition: all 500ms ease;
    -ms-transition: all 500ms ease;
    -o-transition: all 500ms ease;
}
 .sticky-header {
    z-index:106;
    opacity: 1;   
     display: flex;
    align-items: center;
    visibility: visible;
    justify-content:space-between;
    -ms-animation-name: fadeInAnimation;
    -moz-animation-name: fadeInAnimation;
    -op-animation-name: fadeInAnimation;
    -webkit-animation-name: fadeInAnimation;
    animation-name: fadeInAnimation;
    -ms-animation-duration: 500ms;
    -moz-animation-duration: 500ms;
    -op-animation-duration: 500ms;
    -webkit-animation-duration: 500ms;
    animation-duration: 500ms;
    -ms-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
    -op-animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -ms-animation-iteration-count: 1;
    -moz-animation-iteration-count: 1;
    -op-animation-iteration-count: 1;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
}



.main-page{
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 120px;
    position:absolute;
   top:27rem;
   z-index:99;
       left: 12%;
    color:#fff;     
    button{
      width: 150px;
      height:50px;
      background: #FFFFFF;
      border-radius: 30px;
      color:#232533;
      font-size:17px;
      border:0;
      outline:none;      
    }  
}
.main-pages{
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 120px;
    position:absolute;
   top:27rem;
   z-index:99;
       left: 2%;
    color:#fff;     
    button{
      width: 150px;
      height:50px;
      background: #FFFFFF;
      border-radius: 30px;
      color:#232533;
      font-size:17px;
      border:0;
      outline:none;      
    }  
}
.main-pages2{
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 120px;
    position:absolute;
   top:27rem;
   z-index:99;
       left:1%;
    color:#fff;     
    button{
      width: 150px;
      height:50px;
      background: #FFFFFF;
      border-radius: 30px;
      color:#232533;
      font-size:17px;
      border:0;
      outline:none;      
    }  
}
.projectList{
  position: absolute;
  bottom:0;
  left:0;
  z-index: 100;
  width: 280px;
  height: 150px;
  background: linear-gradient(#1d4978, #081630);
  display: flex;
  flex-wrap:wrap;
  justify-content:space-around;
  align-items:center;  
}
.projectList>div{
  width: 120px;
  height: 55px;
}
.projectList>div>p{
  color: #fff;
  font-size: 16px;
}
.projectList>div>p>i{
  color: #12baf9;
}
.inputList{
  width: 120px;
  height: 30px;
  background: #1a3c7b;
  border: 2px solid #0f5390;
  margin-top:7px;
  border-radius: 5px;
  letter-spacing:5px;
  color: #65ddd3;
  line-height: 26px;
  text-indent: 1em;
}
      @keyframes move-forever {
       0% {
           transform: translate(-90px)
         }
  
         to {
           transform: translate(85px)
         }
       }
 
 .parallax > use {  
 animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite; }

.parallax > use:nth-child(1) {  
          animation-delay: -2s;  
          animation-duration: 7s; }

.parallax > use:nth-child(2) {   
          animation-delay: -3s; 
          animation-duration: 10s; }

.parallax > use:nth-child(3) {   
          animation-delay: -4s;  
          animation-duration: 13s; }

.parallax > use:nth-child(4) {
          animation-delay: -5s; 
          animation-duration: 20s; }
 
#box{
  width:280px;
  height: 80px;
  background: #eeeeee;
  box-shadow: 0 0 10px #008b9a;
  border: 1px solid #008b9a;
  position: absolute;
  top:10px;
  left: 50%;
  margin-left: -140px;
  color: #fff;
  text-align: center;
}
.box_left{
  width: 239px;
  height: 80px;
  float: left;
}
.box_title{
  width: 238px;
  height: 30px;
  border-bottom: 1px solid #008b9a;
  line-height: 30px;
}
.box_list{
  width: 119px;
  height: 50px;
  float: left;
}
.box_lists{
  border-left: 1px solid #008b9a;
}
.box_list>p:nth-child(1){
  font-size: 20px;
  line-height: 28px;
  color: yellow;
}
.box_lists>p:nth-child(1){
  color: rgb(111, 185, 234);
}
 
.box_right{
  width: 39px;
  height: 80px;
  border-left: 1px solid #008b9a;
  float: left;
}
.box_right i{
  line-height: 80px;
}
 
 
 
.dilog {
  /* width: 180px; */
  height: 80px;
  background: black;
  position: absolute;
  border-radius: 5px;
  border: solid 1px rgb(0, 139, 154);
  z-index: 11111;
  display: flex;
  box-shadow: 0 0 10px rgb(0, 139, 154);
}
.dilog_title {
  text-align: center;
  height: 30px;
  border-bottom: solid 1px grey;
  line-height: 30px;
  color: white;
}
.box_Tips{
  width:96%;
  height: 20px;
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 14px;
  color: #fff;
}
.box_Tips>p{
  white-space: nowrap;
  position: absolute;
  top: 0px;
  left: 0;
  // animation:mymove 30s infinite;
}
 
  body {
    //  background-color: pink;
    .container {
      width: 100%;
      height: 100%;
      display: flex;
      overflow-y:auto;
          transition: all 0.3s ease;
          -moz-transition: all 0.3s ease;
          -webkit-transition: all 0.3s ease;
          -ms-transition: all 0.3s ease;
          -o-transition: all 0.3s ease;
      overflow-x:hidden;
      flex-direction: column;
      align-items: center;
      &-header {
        // background: url("../../assets/img/bg1.png") no-repeat,linear-gradient(#13a8ed,#F86740);          
        width: 100%;        
      //   padding-bottom: 170px;
      //  padding-top: 180px;
      //   height:800px;
      //   position: relative;       
        .titile {
          width: 100%;
          color: #fff;
          font-size: 2.5rem;
          text-align: center;
          position: absolute;
          top: 7em;
        }
        .titile1 {
          width: 100%;
          color: #fff;
          font-size: 1.7rem;
          text-align: center;
          position: absolute;
          top: 13em;
        }
       
      }
     



      .section {
        width: 75%;
        margin:0 auto;
        &-top {
          font-size: 1.3rem;
          font-weight: 700;
        }
        &-content {
          color: #323232;
          font-size: 1rem;

        }
      }
      .sectiontwo {
        width: 55%;
        display: flex;
        margin-top: 3%;
        padding-bottom:2rem;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .imgcont {
          // width:80%;
        }
        &-img {
          width: 20rem;
        }
        h2 {
          text-align: left;
          font-size: 1.3rem;
          color: #020202;
        }
        &-content {
          text-align: left;
          width: 100%;
          color: #646464;
          font-size: 1rem;
        }
      }
      .sectionthree-us{
         width: 100%;
        height: 40rem;            
        display:flex;
        flex-direction: column;
        align-items: center;
        padding-bottom:5rem;
        padding-top:2rem;
      }
      // 移动端样式
      @media (max-width:1200px){ 
        .sticky-header{
          height:52px;
        }
   #otherBottom{
     width:100%;
    //  height: 490px;
     background: #2D313B;
     color:#fff;
     position:relative;

     .otherBottom{
       width: 85%;
       margin:0 auto;
       &-top{
        display: flex;
    align-items: center;
    flex-wrap: wrap;
      padding: 10px 0;
    height:85px;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
         div{
           display: flex;
           width:50%;         
           align-items: center;    
           justify-content: center;       
         }
         span{
          position: relative;
            left: 0.4em;
             text-align: left; 
                opacity: 0.6;
              font-size:14px;
              color: #fb7f37;
          }
       }
       &-center{
         display: flex;
          align-items: flex-start;    
          padding:27px 0 70px;
          flex-wrap: wrap;
          justify-content: space-between;
         p{
           padding-left: 17px;
           font-size:14px;
           color:rgba(255,255,255,0.5);
           text-align:left;
         }
         span{
          font-size:14px;padding-left: 17px;
           color:rgba(255,255,255,0.5);
           text-align:left;
           margin-top: 14px;
           display:block;
         }
         p:hover{
            color:rgba(255,255,255,0.9);
           text-decoration:underline;
             cursor: pointer;
         }
         &-title{
           font-size:16px;padding-left: 17px;
           color:rgba(255,255,255,0.9);
            
         }
         .lines{
           width:33%;
           text-align:left;
         }
         
       }
        &-bottom{
       color:rgba(255,255,255,0.5);
       font-size:12px;
       width:100%;
       position: absolute;
        bottom: 0;
        padding:5px 0;
      border-top:1px solid rgba(255,255,255,0.2);
     }
     }
    
     
   }
   .leftitp{
     text-align:left;
    padding-left: 2em;
   }
    #experie{
   width:100%;
   height:160px;
   background: url(../../assets/img/in_bar.png) 0 0 no-repeat;
   background-size:100% 100%; 
   position:relative;
   padding: 30px 0;
   .sologin{
    color: #fff;
    font-weight: 600;
    width: 60vw;
    text-align: left;
    font-size: 1em;
    padding-left: 10px;
    letter-spacing: 0px;
   }
   button{     
    width: 5rem;
    height: 33px;
    border: 1px solid #F2F5F8;
    position: relative;
    left: 12vw;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0);
    outline: none;
    color: #fff;
   }       
   }
         .menu{
         
    position: absolute;
    right: 10px; 
    width: 32px;
    height: 44px;
    top:3px;   
    background-repeat: no-repeat;
    background-position: center top;
    background-size:72% auto;
    background-image: url(../../assets/img/header_menu_bg.png);

        }
        .menu-show{            
    position: absolute;
    right: 10px; 
    width: 32px;
    height:16px;
    top:15px;   
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 72% auto;
    background-image: url(../../assets/img/header_menu_bg.png);

        }
        .sticky-heard{
        display: flex;
         width: 100%;    
        height: 69px;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        top: 0;
        &-title{          
          margin-left:14vw;
        }
        &-tab{
                display:none;
                width:1000px;    
                margin-right: 8vw;
                font-size:16px;                              
                justify-content: space-around;
                span{
                  width: 104px;
                  height: 34px;
                  line-height:34px;
                  cursor: pointer;
                  transition: all 500ms ease;
                  color:#444;
                   
                }
                span:hover{
                   color:#f8714d;
                   text-decoration:underline;
                   
                }
                .login:hover{                        
                // color:#4A72E3;
                // background: #FFFFFF;
                  color:#f8714d;
                text-decoration:none;
                border-radius: 3px;
    
                }
            }
      }
         .over-heard{
        display: flex;
         width: 100%;    
        height:52px;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        z-index:99;
        top: 0;
        &-title{          
          position: absolute;
    top: 0;
    left: 23px;
        }
        &-tab{
                display:none;
                width:1000px;    
                margin-right: 8vw;
                font-size:16px;                               
                justify-content: space-around;
                span{
                  width: 104px;
                  height: 34px;
                  line-height:34px;                  
                  cursor: pointer;
                  transition: all 500ms ease;
                  color:rgba(255,255,255,0.8);
                   
                }
                span:hover{
                   color:#fff;
                   text-decoration:underline;
                   
                }
                .login:hover{                        
                color:#F86740;
                background: #FFFFFF;
                text-decoration:none;
                border-radius: 3px;
    
                }
            }
      }
        //  关于我们
#aboutUs{
   background: url(../../assets/img/aboutus.jpg) 0 0 no-repeat;
  background-size: 100% 10rem;
   .section-top{
    //  position: relative;
    // top: 1.5em;
   }
   .aboutUs{
     position:relative;
   &-cover{
    //  width: 1203px;
    //   height: 464px;
       margin: 0 auto;
      background: #FFFFFF;
      position: relative;
      z-index:9;
       top:1em;
      box-shadow: 0px 0px 54px 0px rgba(138, 151, 189, 0.15);
      border-radius: 10px;
   }
   &-top{
     color:#504F5B;
     font-size:14px;
     text-align: left;
     padding: 28px 15px 20px 15px;
     &-message{
       color:#0E0806;        
       font-size:16px;
       cursor: pointer;
     }
   }
   &-bottom{
     display: flex;     
    width: 90%;   
    border-top: 1px solid #ECECEC;
    margin: 0 auto;
    position: relative;
    transition: all 0.5s !important;
    top: 1em; 
    padding: 15px 0 15px;
    flex-wrap: wrap;
    div{
      width:50%;
    }
    img{
     position: relative;
    top:2px;
    width: 20px;
    height: 20px;
    object-fit: contain;
    }
    p{
      color:#232533;
      font-size:16px;
    }
    span{
      color:#232533;
     font-size: 1.23rem;
      position: relative;
      left: 6px;
    }
   }
   }
    
}

           .serviceguarantee:hover{
     .color-layer{
       display:flex;
       justify-content: center;
    align-items: center;

       p{
       z-index: 99;
    position: absolute;
    font-size: 0.78rem;
    color: #fff;
    width: 84%;
    text-align: left;
    padding: 0 10px;
    padding-right: 19%;
    line-height: 15px;
    letter-spacing: 0;
    display: block;
       }
     }
      .color-layer:after {              
              transform: rotateY(0deg);              
              }
                .color-layer:before{
                   transform: rotateY(0deg);  
                }
   }
   .callus{
  width: 25px;
height: 100px;
cursor: pointer;
background: #FFFFFF;
box-shadow: 0px 0px 18px 0px rgba(201, 193, 191, 0.16), 0px 0px 10px 0px rgba(4, 0, 0, 0.1);
border-radius: 20px;
img{
  width: 25px;
    object-fit: contain;
    height: 25px;
}
p{
   width: 15px;
    height: 70px;
    font-size: 0.75rem;
    font-weight: 500;
    color: #504F5B;
    text-align: center;
    line-height: 16px;
    position: relative;
    left: 5px;
    bottom:10px;
}
.showQu{
  display:none;
}
}
        .callUs{
   position: absolute;
  bottom:66px;
  display: flex;
  right:8px;
  z-index: 100;
   .showQu{
  width: 190px;
  height: 100px;   
  background: #F7F7F9;
  border-radius: 10px;  
  margin-right: 10px;
 .mainQu{    
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    top: 6px;
 }
 .show-name{
   color: #504F5B;
    font-size:0.8rem;
    letter-spacing:0;
 }
}
}
           .serviceguarantee{
      //  width:384px;
      height: 160px;
      width:47%;
      background: #FFFFFF;
      border: 1px solid #ECECEC;    
      border-radius: 10px;
      // margin: 15px;
      display: flex;
      cursor: pointer;
      margin:1%;
    flex-direction: column;
    align-items: flex-start;
    position:relative;
    font-weight: 500;
    color: #232533;
    img{
      width:25px;
    height:25px;
    object-fit: contain;
    }
    .color-layer{
               position: absolute;
                content: '';
                left: 0px;
                top: 0px;
                right: 0px;
                bottom: 0px;
                border-radius: 10px;
             }
    font-size:20px;
    span{
      padding:1.6rem 40px;
    }
    div{
    padding-left: 2rem;
    font-size: 1rem;
    text-align:left;
    }
   }
            .sectionthree {
        width: 100%;          
          animation: fadeInshow ease 3s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards;   
        // display:flex;
        // flex-direction: column;
        // align-items: center;
        //  padding-bottom:5rem;
        //  padding-top:2rem;
        .section {         
        &-top {
          font-size: 1.3rem;
          font-weight: 700;
          h2{
            font-size:1.5rem;
            font-family:myFont;
            font-weight: 500;
            color: #130D0C;
          }
           .sm-title{
            font-size: 0.9rem;
           font-family:myFont;
           position: relative;
            bottom: 9px;
            font-weight: 500;
            color: #B9B9B9;
          }
        }
        &-content {
          color: #323232;
          font-size: 1rem;

        }
      }
     
        &-img{           
        width: 2rem;
    object-fit: contain;
        }
        &-main{
          width: 75%;        
          margin:0 auto;
        }
         &-nav{
         height:192px;
         width:46%;
         margin:2%;
        position: relative;
        border-radius: 1px;
        padding-top: 20px;
        cursor: pointer;
        transition: all 0.5s !important;         
                      
            p{
              &:nth-child(2){
           font-size:1rem;
            font-family:myFont;
            font-weight: 500;
            color: #232533;
            // line-height: 24px;
            }
            &:nth-child(3){
             font-size: 0.75rem;
              font-family:myFont;
              font-weight: 500;             
              color: #7F7F86;    
              position:relative;
              bottom:10px;  
              text-align:left;
              padding: 0 13px;         
            }
            }
            &-line{
             width:0;
              transition:width 2s;
              -moz-transition:width 2s; /* Firefox 4 */
              -webkit-transition:width 2s; /* Safari and Chrome */
              -o-transition:width 2s; /* Opera */ 
              height:2px;              
              position: absolute;
              background:#fa8565;   
              left: 0;
              bottom: 0;              
              right: 0;            
            }

          }
    
 
          &-nav:hover{
             box-shadow: 0 3px 5px rgba(4,0,0,.2 );    
            
                p{
              &:nth-child(2){
           font-size:1rem;
            font-family:myFont;
            font-weight: 500;
            color: #fa8565;
            // line-height: 24px;
            }
            &:nth-child(3){
             font-size: 0.75rem;
              font-family:myFont;
              font-weight: 500;               
              color: #232533;               
            }
            }         
          }
          &-role{
                 -webkit-animation: fadeInUp ease 0.5s;
                  animation: fadeInUp ease 0.5s;
                  transition: all 0.5s !important;                   
                  height: 210px;
                margin:2%;width: 46%;
                  background: #FFFFFF;                 
                  border-radius: 10px;
                  transition: all 600ms ease;
                  position: relative;             
             .sectionthree-img1{
              display: block;
              position: relative;
              width: 30px;
              height: 30px;
                transform: rotateY(0deg);
              top: 15px;
              z-index: 99;
              object-fit: contain;
              margin: 5px auto 0 auto;
             }
           .sectionthree-img2{
               display:none;
             }

 
            h4{              
              height: 19px;
              font-size:1rem;
              font-family: PingFang SC;
              font-weight: 500;        
              position: relative;
               z-index: 99;      
              margin-bottom: 35px;
              color: #232533;
              line-height: 72px;
            }
            p{             
              height: 14px;
              font-size:0.75rem;
              position: relative;
               z-index: 99;
              font-family: PingFang SC;
              font-weight: 400;
              color: #504F5B;              
             
            }      
            
          }
          &-role:hover{         
             box-shadow: 0px 0px 32px 0px rgba(138, 151, 189, 0.2); 
               transition: all 0.5s !important;    
               h4{
                 color:#F86740 !important;                  
               }               
               .sectionthree-img1{
                    transition: all 1000ms ease;
                  transform: rotateY(180deg);
               }             
              // transform: translate(0,-20px) rotate(0deg) !important;/*x轴不动，y轴向上平移20px 不旋转*/             
             .color-layer:after {              
              transform: rotateY(0deg);              
              }
                .color-layer:before{
                   transform: rotateY(0deg);  
                }
         

 
          }
          
      }
      .back_to_top{
  position: absolute;
 bottom:2.2rem;
  right:0.2rem;  
  z-index: 100;
  width:2rem;
}
 .waves {
  position: absolute;
    left: 0px;    
    width: 100%;
    height: 15vh;
    top:145px;
    margin-bottom: -8px;    
    min-height: 100px;
    z-index: 99;
    max-height: 150px;
}

 
 //产品方案
 #projectCase{
   background: url(../../assets/img/phimg.jpg) 0 0 no-repeat;
   background-size: 100%;
   animation: fadeInshow ease 3s;
animation-iteration-count: 1; /*设置动画播放次数*/
animation-fill-mode: forwards;
   color:#fff;
   h2{
     color:#fff;
   }
   .pro-container{
     display:flex;
     justify-items:center;
    //  align-items:center;
     height:360px;
     .proLeft{
       width:9rem;       
       p{
         height:55px;          
         line-height:55px;
         text-align: left;
          cursor: pointer;
         padding-left: 24%;
          animation: fadeInAnimation ease 3s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards; 
         img{
           position: relative;
           bottom:-2px;
            height:15px;
            height:15px;
         }
       }
     }
  
   }

 }


  .proRight{       
        width: 49vw;       
        height: 341px;
        text-align: left;
        // background: pink;      
            display: flex;
            position: relative;
            top:1rem;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;  
            margin-left: 4vw;
        border-bottom:1px dashed rgba(242, 245, 248,0.3);
        P:nth-child(1){
         font-size: 1.1rem;
          position: relative;
          top:-2px;
  
    color: rgba(255,255,255,.9);
        }
         P:nth-child(2){          
         position: relative;
          bottom: 9px;
          font-size: 0.9rem;
          color: rgba(255,255,255,.8);
        }
        p{
          animation: fadeInAnimation ease 3s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards; 
        }
        .probut{
          width: 140px;
          height: 40px;
          background: linear-gradient(0deg, #F86740 0%, #FFA128 100%);
          border-radius: 6px;
          border:0;
          animation: fadeInAnimation ease 3s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards; 
          outline:none;
          color:#fff;
          position:relative;
          top:10px;
        }
     }
     .qurshowcode{
       width: 48px;height: 48px;object-fit: contain;
     }
       #hiddens{
       display:none;
      }
       #inherits{
         display:block;
      }
      
// 联系我们
#contactUs{
   background: url(../../assets/img/contact_us_bg.jpg) 0 0 no-repeat;
    background-size: 100% 10rem;   
  .section-top{
    // margin-top: 5.5em;
  }
  .contactUs{
    // width:1200px;
    height:360px;   
     background: url(/static/img/tiyan@1.5dc486f6.png) 0 0 no-repeat;
    background-size: 100% 100%;
    background-color:#fff;
    position: relative;
    text-align:left;
    box-shadow: 0px 0px 54px 0px rgba(138, 151, 189, 0.15);
     margin:0 auto;
    top: 1.4em;
    padding-top:3rem;
    // margin-bottom: 4em;
    &-box{
      padding: 10px 24px;  
          margin: 0 auto;
        position: relative;
          // top: 11%;
    }
    &-title{
      color:#232533;
      font-size:20px;
      margin-bottom: 3%;
    }
    &-tab{
      display:flex;
      justify-content:flex-start;
      align-items:center;
      margin-bottom:1%;
    }
    &-line{
      margin-right:2em;
      display:flex;
      align-items:center;
      img{
        margin-right:10px;      
        width: 25px;
        height: 25px;
        object-fit: contain;position:relative;
        bottom: 17px;
      }
      &-message{
        font-weight: 500;
        color: #504F5B;
        font-size:1rem;     
         
        // line-height:10px;
      }
    }
  }

}
  .tagimg1 {
    position: absolute;
   left: 18%;
    top: 23%;
      height: 40px;
    width: 40px;
    font-size: 0.8rem;
    object-fit:contain;
}
.tagimg4 {
    position: absolute;
    bottom:10%;
    left: 12%;
    height: 40px;
    width: 40px;
    font-size: 0.8rem;
   
}
.tagimg2{
   position: absolute;
    right:9%;
    bottom: 1%;
      height: 40px;
    width: 40px;
    font-size: 0.8rem;
    object-fit:contain;
}
.tagimg3{
  position: absolute;
     top:50%;
    right:20%;
     height: 40px;
    width: 40px;
    font-size: 0.8rem;
    object-fit:contain;
}
   .container .el-carousel__indicator--vertical .el-carousel__button {
    width: 8px !important;
    height: 8px !important;   
    border-radius: 50% !important;
    margin:2px 0;   
}
  } 
  // pc端样式
    @media (min-width:1200px){
    
   .container .el-carousel__indicator--vertical .el-carousel__button {    
    margin-right:40px !important;     
}
      .tagimg1{
   position: absolute;
    left: 35%;
    font-size:14px;
    top: 19%;
}
.tagimg2{
   position: absolute;
    right: 35%;
    bottom: 10%;
    font-size:14px;
}
.tagimg3{
  position: absolute;
     top: 38%;
     font-size:14px;
    right:10%;
}
.tagimg4{ 
  position: absolute;
    top:43%;
    font-size:14px;
    left: 9%;
}
        .aboutUs-bottom div{transition: all 0.5s !important;cursor: pointer;}   
    .aboutUs-bottom div:hover{
      transform: translate(0,-15px) rotate(0deg) !important;/*x轴不动，y轴向上平移20px 不旋转*/
    }
      
// 联系我们
#contactUs{
   background: url(../../assets/img/contact_us_bg.jpg) 0 0 no-repeat;
   background-size:100%;
  .section-top{
   position: relative;
    bottom: 2rem;
  }
  .contactUs{
    width:1200px;
    height: 400px;   
    background: url(../../assets/img/cont_con_bg.png) 0 0 no-repeat;
     background-size: 100% 100%;  
    background-color:#fff;
    position: relative;
    text-align:left;
    box-shadow: 0px 0px 54px 0px rgba(138, 151, 189, 0.15);
     margin:0 auto;
    top: 1.4em;
    padding-top:1rem;
    margin-bottom: 4em;
    &-box{
      width: 77%;    
    margin: 0 auto;
    margin-top: 4%;
    }
    &-title{
      color:#232533;
      font-size:20px;
      margin-bottom: 3%;
    }
    &-tab{
      display:flex;
      justify-content:flex-start;
      align-items:center;
      margin-bottom:1%;
    }
    &-line{
      margin-right:2em;
      display:flex;
      align-items:center;
      img{
        margin-right:10px;
      }
      &-message{
        font-weight: 500;
        color: #504F5B;
        font-size:16px;       
        line-height:10px;
      }
    }
  }
}
      .hiddens{
        visibility:hidden;
      }
       .inherits{
        visibility:inherit;
      }
      .callus{
  width: 40px;
height: 133px;
cursor: pointer;
background: #FFFFFF;
box-shadow: 0px 0px 18px 0px rgba(201, 193, 191, 0.16), 0px 0px 10px 0px rgba(4, 0, 0, 0.1);
border-radius: 20px;
p{
     width: 15px;
    height: 73px;
    font-size: 16px;
    font-weight: 500;
    color: #504F5B;
    text-align: center;
    line-height:19px;
    position: relative;    
    left: 11px;
    bottom:13px;
}
.showQu{
  display:none;
}
}
       .proRight{       
        width: 49vw;       
        height: 341px;
        text-align: left;
        // background: pink;      
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;  
            margin-left: 4vw;
        border-bottom:1px dashed rgba(242, 245, 248,0.3);
        P:nth-child(1){
          font-size:23px;
          position: relative;
          bottom: 15px;
        }
         P:nth-child(2){          
          position: relative;
          bottom:29px;
        }
        p{
          animation: fadeInAnimation ease 3s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards; 
        }
        .probut{
          width: 140px;
          height: 40px;
          background: linear-gradient(0deg, #F86740 0%, #FFA128 100%);
          border-radius: 6px;
          border:0;
          animation: fadeInAnimation ease 3s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards; 
          outline:none;
          color:#fff;
          position:relative;
         bottom: 10px;
        }
     }
 //产品方案
 #projectCase{
   background: url(../../assets/img/index_solution_bg3.png) 0 0 no-repeat;
   animation: fadeInshow ease 3s;
animation-iteration-count: 1; /*设置动画播放次数*/
animation-fill-mode: forwards;
   color:#fff;
   h2{
     color:#fff;
   }
   .pro-container{
     display:flex;
     justify-items:center;
     align-items:center;
     height:360px;
     .proLeft{
       width:200px;       
       p{
         height:55px;          
         line-height:55px;
         text-align: left;
          cursor: pointer;
         padding-left: 24%;
          animation: fadeInAnimation ease 3s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards; 
         img{
           position: relative;
           top: 5px;
         }
       }
     }
  
   }

 }

      .sticky-header{
        height:69px;
      }
      .waves {
  position: absolute;
    left: 0px; 
    width: 100%;
    height: 15vh;
    top: 700px;
    margin-bottom: -8px;     
    min-height: 100px;
    z-index: 99;
    max-height: 150px;
}
      .back_to_top{
  position: absolute;
 bottom: 1rem;
  right: 2.7rem;
  cursor: pointer;
  z-index: 100;
}
   #otherBottom{
     width:100%;
     height: 490px;
     background: #2D313B;
     color:#fff;
     position:relative;

     .otherBottom{
       width: 70%;
       margin:0 auto;
       &-top{
         display:flex;
         align-items:center;
         height: 140px;
         justify-content:space-between;
         border-bottom:1px solid rgba(255,255,255,0.2);
         div{
           display: flex;
           align-items: center;           
         }
         span{
             position:relative;left:10px;
             opacity: 0.6; 
             color: #fb7f37;
          }
       }
       &-center{
         display: flex;
          align-items: flex-start;    
          padding:75px 0;
          justify-content: space-between;
         p{
           font-size:14px;
           color:rgba(255,255,255,0.5);
           text-align:left;
         }
         span{
          font-size:14px;
           color:rgba(255,255,255,0.5);
           text-align:left;
           margin-top: 14px;
           display:block;
         }
         p:hover{
            color:rgba(255,255,255,0.9);
           text-decoration:underline;
             cursor: pointer;
         }
         &-title{
           font-size:16px;
           color:rgba(255,255,255,0.9);
         }
         
       }
        &-bottom{
       color:rgba(255,255,255,0.5);
       font-size:12px;
       width:100%;
       position: absolute;
        bottom: 0;
        padding:5px 0;
      border-top:1px solid rgba(255,255,255,0.2);
     }
     }
    
     
   }
      #experie{
   width:100%;
   height:160px;
   background: url(../../assets/img/in_bar.png) 0 0 no-repeat;
   background-size:100% 100%; 
   position:relative;
   padding: 59px 0;
   .sologin{
     color: #fff;
    font-weight: 800;
   
    font-size: 28px;
   
    letter-spacing: 2px;
   }
   button{     
    width: 140px;
    height: 40px;
    border: 1px solid #F2F5F8;
    position: relative;
    left:3vw;
    border-radius: 4px;
    background:rgba(255,255,255,.0);
    outline:none;
    color:#fff;
   }       
   }
      .menu{
            display:none;
        }
        .menu-show{
          display:none;
        }
       .sticky-heard{
        display: flex;
         width: 100%;    
        height: 69px;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        top: 0;
        &-title{          
          margin-left:14vw;
        }
        &-tab{               
                width:1000px;    
                margin-right: 8vw;
                font-size:16px;            
                display: flex;               
                justify-content: space-around;
                span{
                  width: 104px;
                  height: 34px;
                  line-height:34px;
                  cursor: pointer;
                  transition: all 500ms ease;
                  color:#444;
                   
                }
                span:hover{
                   color:#f8714d;
                   text-decoration:underline;
                   
                }
                .login:hover{                        
                // color:#4A72E3;
                // background: #FFFFFF;
                  color:#f8714d;
                text-decoration:none;
                border-radius: 3px;
    
                }
            }
      }
       .over-heard{
        display: flex;
         width: 100%;    
        height: 69px;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        z-index:99;
        top: 0;
        &-title{          
          margin-left:14vw;
        }
        &-tab{
                display:flex;
                width:1000px;    
                margin-right: 8vw;
                font-size:16px;            
                display: flex;               
                justify-content: space-around;
                span{
                  width: 104px;
                  height: 34px;
                  line-height:34px;                  
                  cursor: pointer;
                  transition: all 500ms ease;
                  color:rgba(255,255,255,0.8);
                   
                }
                span:hover{
                   color:#fff;
                   text-decoration:underline;
                   
                }
                .login:hover{                        
                color:#F86740;
                background: #FFFFFF;
                text-decoration:none;
                border-radius: 3px;
    
                }
            }
      }
      //  关于我们
#aboutUs{
   background: url(../../assets/img/aboutus.jpg) 0 0 no-repeat;
   background-size: 100%;
   .section-top{
    //  position: relative;
    // top: 1.5em;
   }
   .aboutUs{
     position:relative;
   &-cover{
     width: 1203px;
      height: 464px;
       margin: 0 auto;
      background: #FFFFFF;
      position: relative;
      z-index:9;
       top:2.3em;
      box-shadow: 0px 0px 54px 0px rgba(138, 151, 189, 0.15);
      border-radius: 10px;
   }
   &-top{
     color:#504F5B;
     font-size:14px;
     text-align: left;
     padding: 32px 72px 20px 72px;
     &-message{
       color:#0E0806;        
       font-size:16px;
       cursor: pointer;
     }
   }
   &-bottom{
     display: flex;
    justify-content: space-between;
    width: 90%;
    align-items: center;
    border-top: 1px solid #ECECEC;
    margin: 0 auto;
    position: relative;
     transition: all 0.5s !important;    
    top: 1em;
    text-align: left;
   padding: 15px 0 15px;
    img{
      position: relative;
      top: 8px;
    }
    p{
      color:#232533;
      font-size:16px;
    }
    span{
      color:#232533;
      font-size:24px;
      position: relative;
      left: 15px;
    }
   }
   }
    
}

         .serviceguarantee:hover{
     .color-layer{
       p{
         z-index: 99;
    position: absolute;
    font-size: 15px;   
    color: #fff;
    text-align: left;
    padding-right: 50px;
    padding-top: 16px;
     letter-spacing:0;
    display:block;
       }
     }
      .color-layer:after {              
              transform: rotateY(0deg);              
              }
                .color-layer:before{
                   transform: rotateY(0deg);  
                }
   }
      .callUs{
   position: absolute;
  bottom: 8%;
  display: flex;
  right:3rem;
  z-index: 100;
   .showQu{
  width: 190px;
  height: 134px;   
  background: #F7F7F9;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 10px;
 .mainQu{    
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    top: 18px;
 }
 .show-name{
   color: #504F5B;
    font-size: 14px;
    letter-spacing:0;
 }
}
}
         .serviceguarantee{
       width:384px;
      height: 160px;
      background: #FFFFFF;
      border: 1px solid #ECECEC;
      border-radius: 10px;
      margin: 15px;
      display: flex;
      cursor: pointer;
    flex-direction: column;
    align-items: flex-start;
    position:relative;
    font-weight: 500;
    color: #232533;
    .color-layer{
               position: absolute;
                content: '';
                left: 0px;
                top: 0px;
                right: 0px;
                bottom: 0px;
                border-radius: 10px;
             }
    font-size:20px;
    span{
      padding:28px 40px;
    }
    div{
      padding-left:40px;
    }
   }
      .sectionthree {
        width: 100%;
        height: 40rem;     
          animation: fadeInshow ease 3s;
          animation-iteration-count: 1; /*设置动画播放次数*/
          animation-fill-mode: forwards;   
        // display:flex;
        // flex-direction: column;
        // align-items: center;
         padding-bottom:5rem;
         padding-top:2rem;
        .section {
        width: 55%;
        &-top {
          font-size: 1.3rem;
          font-weight: 700;
          h2{
            font-size: 30px;
            font-family:myFont;
            font-weight: 500;
            color: #130D0C;
          }
           .sm-title{
            font-size: 16px;
          font-family:myFont;
           position: relative;
            bottom: 9px;
            font-weight: 500;
            color: #B9B9B9;
          }
        }
        &-content {
          color: #323232;
          font-size: 1rem;

        }
      }
     
        &-img{           
          margin-top: 35px;
        }
        &-main{
          width: 75%;
          display: flex; 
          justify-content:center;
          align-items: center;  
          margin:0 auto;
        }
         &-nav{
           width: 282px;           
           height: 300px;position:relative;            
            border-radius:1px;cursor: pointer;
            transition: all 0.5s !important;                
            margin-top:60px;                             
            p{
              &:nth-child(2){
             font-size: 20px;
            font-family:myFont;
            font-weight: 500;
            color: #232533;
            // line-height: 24px;
            }
            &:nth-child(3){
              font-size: 14px;
              font-family:myFont;
              font-weight: 500;
              padding: 0 40px 0 40px;
              color: #7F7F86;               
            }
            }
            &-line{
             width:0;
              transition:width 2s;
              -moz-transition:width 2s; /* Firefox 4 */
              -webkit-transition:width 2s; /* Safari and Chrome */
              -o-transition:width 2s; /* Opera */ 
              height:2px;              
              position: absolute;
              background:#fa8565;   
              left: 0;
              bottom: 0;              
              right: 0;            
            }

          }
          &-nav:hover{
              box-shadow: 0px 0px 32px 0px rgba(138, 151, 189, 0.15); 
               transition: all 0.5s !important;                                
              transform: translate(0,-20px) rotate(0deg) !important;/*x轴不动，y轴向上平移20px 不旋转*/                   
          }
          &-role{
            animation: fadeInUp ease 0.5s;
             transition: all 0.5s !important;                   
            width: 282px;
            cursor: pointer;
            height: 280px;            
            background: #FFFFFF;
            box-shadow: 0px 0px 32px 0px rgba(138, 151, 189, 0.15);
            border-radius: 10px;         
            transition: all 600ms ease;      
            position: relative; 
              margin-top:60px;    
             margin-right: 25px;                
             .sectionthree-img1{
               display:block;      
               position: relative;
               z-index: 99;         
               margin: 35px auto 0 auto;
             }
           .sectionthree-img2{
               display:none;
             }

 
            h4{              
              height: 19px;
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 500;        
              position: relative;
               z-index: 99;      
              margin-bottom: 35px;
              color: #232533;
              line-height: 72px;
            }
            p{             
              height: 14px;
              font-size: 14px;
              position: relative;
               z-index: 99;
              font-family: PingFang SC;
              font-weight: 400;
              color: #504F5B;              
              line-height: 28px;
            }      
            
          }
          &-role:hover{         
             box-shadow: 0px 0px 32px 0px rgba(138, 151, 189, 0.15); 
               transition: all 0.5s !important;                                
              transform: translate(0,-20px) rotate(0deg) !important;/*x轴不动，y轴向上平移20px 不旋转*/             
             .color-layer:after {              
              transform: rotateY(0deg);              
              }
                .color-layer:before{
                   transform: rotateY(0deg);  
                }
         

 
          }
          
      }
    }
      .sectionfour{
        width:100%;padding:2rem 0;display:flex;
        justify-content:center;align-items:center;
        &-pic{
          width:50%;      
          text-align:right;padding:0 1rem; 
        }
         &-img{
            width:30rem;
          }
        &-content{
          h3{
            color:#000;padding:0 1rem;
          }
          width:50%;text-align:left;          
           color:#666;
           p{
             width:30rem;
             padding:0 1rem;
           }
        }
      }
      .AboatUs{
        width:100%;background:#f8f8f8;
        height:26rem;
      }
    }
  }
 
 

@-moz-keyframes move{ 
	    0%{transform:translateX(0);}    
	    50%{transform:translateX(-50%);}
	    100%{transform:translateX(-100%);} 
	}
	@-webkit-keyframes move{ 
	    0%{transform:translateX(0);}    
	    50%{transform:translateX(-50%);}
	    100%{transform:translateX(-100%);}
	}
	@keyframes move{ 
	    0%{transform:translateX(0);}    
	    50%{transform:translateX(-50%);}
	    100%{transform:translateX(-100%);}   
	}
 
//  部分高校合作案例
 .cooperation{    
    width:960px;   
    height: 200px;
    position: relative;
    display: flex;
    margin:0 auto;
    justify-content: center;
    &-circle{
      width: 50px;
      height: 50px;
      display: block;
      background: #FFFFFF;
      box-shadow: 0px 0px 32px 0px rgba(138, 151, 189, 0.24);
      border-radius: 50%;
      font-size: 27px;
      color: #B9B9B9;
      line-height: 49px;
    }
    .left-icon{
      position: absolute;
      top: 66px;
      left:-63px;
    }
    .right-icon{
      position: absolute;
      top: 66px;
      right:-63px;
    }
    &-main{
        width:1200px;
        height: 200px;
        // margin: 0 auto;
        height:200px;
        display: flex;
        flex-direction: column;       
        justify-content: center;
        overflow-x:hidden;       
        align-items: flex-start;   
        & ::-webkit-scrollbar {display:none}
        
        &-logoBox{
          display:flex;
          justify-content: center; 
            transition: all 0.3s ease;
            -moz-transition: all 0.3s ease;
            -webkit-transition: all 0.3s ease;
            -ms-transition: all 0.3s ease;
            -o-transition: all 0.3s ease; 
          // -moz-animation: move 32s infinite linear;
          // -webkit-animation: move 32s infinite linear;
          // animation: move 32s infinite linear;   
          // white-space: nowrap;     
           margin-bottom:20px;     
        }
         &-logoCover{
         display:flex;
          justify-content: center; 
          margin-bottom:20px;    
            transition: all 0.3s ease;
          -moz-transition: all 0.3s ease;
          -webkit-transition: all 0.3s ease;
          -ms-transition: all 0.3s ease;
          -o-transition: all 0.3s ease;
         }
        img{
          // width:240px;
          // height: 44px;
     
          // object-fit: contain;
        }         
    }
 }
 #experie{
   width:100%;
   height:160px;
   background: url(../../assets/img/in_bar.png) 0 0 no-repeat;
   background-size:100% 100%; 
   position:relative;
   padding: 59px 0;
   .sologin{
     color: #fff;
    font-weight: 800;
   
    font-size: 28px;
   
    letter-spacing: 2px;
   }
   button{     
    width: 140px;
    height: 40px;
    border: 1px solid #F2F5F8;
    position: relative;
    left:3vw;
    border-radius: 4px;
    background:rgba(255,255,255,.0);
    outline:none;
    color:#fff;
   }       
   }


 .leftBut{
   transition:0.3s all;
   border-left:4px solid #FFA128;  
   background:linear-gradient(to right,rgba(255, 255, 255,0.6),rgba(255, 255, 255,0))
 }
 .leftLine{
     border-left:4px solid rgba(242, 245, 248,0);
 }

.owl-dots {
  display:flex;
  justify-content: center;

}
 .owl-dot {
    position: relative;
    width: 8px;height: 8px;
    margin: 0px 4px;
     cursor: pointer;
    border-radius: 50px;
    display: inline-block;
    background-color: #ECECEC;
    transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
}
.owl-dot:hover {
    width: 30px;
    background-color: #F86740;
}
.owl-dob{
  width: 30px;
  background-color: #F86740; 
}
.otherClass{
  text-decoration:underline !important;
  color:#F86740!important;
}
.loginbtn:hover{                        
      color:#fff !important;
      background:#F86740;
      text-decoration:none !important;
      border-radius: 3px;
    }
    .Fade-enter,
.Fade-leave-to {
	opacity: 0;
}
.Fade-enter-to,
.Fade-leave {
	opacity: 1;
}

.Fade-enter-active,
.Fade-leave-active {
	transition: all .2s;
}	
 .container::-webkit-scrollbar {
	  width : 0px;  /*高宽分别对应横竖滚动条的尺寸*/
	  height:0px;
  }
  /*滚动条里面小方块*/
  .container::-webkit-scrollbar-thumb { 
	 display:none;
  }
  /*滚动条里面轨道*/
  .container::-webkit-scrollbar-track { 
	   display:none;
  }
 button{
    cursor: pointer;
 }
 .showNavleft{   
    animation: fadeInshowLeft ease 2s;         
 }
 .showNavRight{  
   animation: fadeInshowRight ease 2s;           
 } 
 #button:hover{                        
      color:#F86740 !important;
      background:#fff;
      text-decoration:none !important;       
    }
      
   
  //    .el-carousel__item h3 {
  //   color: #475669;
  //   font-size: 14px;
  //   opacity: 0.75;
  //   line-height: 200px;
  //   margin: 0;
  // }
  
  // .el-carousel__item:nth-child(2n) {
  //   background-color: #99a9bf;
  // }
  
  // .el-carousel__item:nth-child(2n+1) {
  //   background-color: #d3dce6;
  // }
  .newsBox{
    width: 280px;
    height: 130px;
    background: #FFFFFF;
    border-radius: 6px;
    display: flex;
      margin: 0 6px;
    padding: 10px 20px;
    border: 1px solid rgba(0,0,0,.0);
    align-items: center;
    img{
      width: 95px;
    height: 95px;
    object-fit: cover;
    position: relative;
    border-radius: 5px;
    top:3px;
 
    }
    .newstitle{
      font-size: 15px;
    letter-spacing: 0px;
    text-align: left;
    color: #F86740;
  padding: 0px 10px 3px 10px;
    }
    .newsDetail{
       font-size: 13px;
    letter-spacing: 0px;
    text-align: left;
    color: #8D8D8D;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
     padding: 3px 10px;
    -webkit-box-orient: vertical;

    }
    .newsctime{
      color:#B9B9B9;
      padding:0px 10px;
      font-size: 12px;
      text-align: left;
    
    }
  }
   
   .newscontain{    
          width: 1008px;
    height: 350px;
    position: relative;
    display: flex;
    margin: 0 auto;
    justify-content: center;
    &-circle{
      width: 50px;
      height: 50px;
      display: block;     
      box-shadow: 0px 0px 32px 0px rgba(138, 151, 189, 0.24);
      border-radius: 50%;
      font-size: 27px;    
      line-height: 49px;
    }
    .getItcheck{
      background: #F86740;
      color:#fff      
    }
    .nocheck{
      background: #FFFFFF;
      color:#B9B9B9      
    }
    .left-icon{
      position: absolute;
      top:36%;
      left:-63px;
    }
    .right-icon{
      position: absolute;
      top:36%;
      right:-63px;
    }
    &-main{
        width:1200px;
        height: 350px;
        // margin: 0 auto;
      
        display: flex;
        flex-direction: column;       
        justify-content: center;
        overflow-x:hidden;       
        align-items: flex-start;   
        & ::-webkit-scrollbar {display:none}
        
        &-logoBox{
          display:flex;
          justify-content: center; 
            transition: all 0.3s ease;
            -moz-transition: all 0.3s ease;
            -webkit-transition: all 0.3s ease;
            -ms-transition: all 0.3s ease;
            -o-transition: all 0.3s ease; 
          // -moz-animation: move 32s infinite linear;
          // -webkit-animation: move 32s infinite linear;
          // animation: move 32s infinite linear;   
          // white-space: nowrap;     
           margin-bottom:10px;     
        }
         &-logoCover{
         display:flex;
          justify-content: center; 
          margin-bottom:10px;    
            transition: all 0.3s ease;
          -moz-transition: all 0.3s ease;
          -webkit-transition: all 0.3s ease;
          -ms-transition: all 0.3s ease;
          -o-transition: all 0.3s ease;
         }
        img{
          // width:240px;
          // height: 44px;
     
          // object-fit: contain;
        }         
    }
 }
   .newsBox:hover{
    box-shadow: 0px 0px 20px 0px rgba(147, 150, 159, 0.24);
   }


   .color-layer{
               position: absolute;
                content: '';
                left: 0px;
                top: 0px;
                right: 0px;
                bottom: 0px;
                border-radius: 10px;
                p{
                  display:none;
                }
             }
              .color-layer:after {
              position: absolute;
              content: '';
              right:1px;
              top: 0px;
              width: 50%;
              height: 100%;
              opacity: 1;              
              background:linear-gradient(#F86740,#FFA128);
              border-top-right-radius:10px !important;
              border-bottom-right-radius:10px !important;
              transform: rotateY(90deg);
              border-radius: 0px;
              transition: all 500ms ease;
              -moz-transition: all 500ms ease;
              -webkit-transition: all 500ms ease;
              -ms-transition: all 500ms ease;
              -o-transition: all 500ms ease;
              }
              .color-layer:before {
              position: absolute;
              content: '';
              left: 1px;
              top: 0px;
              width: 50%;
              height: 100%;
              opacity:1;
               border-top-left-radius:10px !important;
              border-bottom-left-radius:10px !important;
              background:linear-gradient(#F86740,#FFA128);
              transform: rotateY(90deg);
              border-radius: 0px;
              transition: all 500ms ease;
              -moz-transition: all 500ms ease;
              -webkit-transition: all 500ms ease;
              -ms-transition: all 500ms ease;
              -o-transition: all 500ms ease;
}

.free-btn:hover{
  color:#F86740 !important; 
}
 




.callus:hover{
  p{
    color:#F86740;
  }

}
 .calltel{
 font-weight: 500;
    text-align: left;
    color: #504F5B;
    font-size: 15px;
    line-height: 10px;
    text-decoration:none;
    cursor: pointer;
}
.tagti1{  
  background:#fff1eb;
  margin-top: 0px;
  width:4.5rem;
  height:4.5rem;
  display:flex;
  align-items:center;
  justify-content:center;  
  color:#f86943;
  border-radius:50%;
    
   
}  
  .carousel .el-carousel__indicator--vertical .el-carousel__button {
    width: 15px !important;
    height: 15px !important;   
    border-radius: 50% !important;
    margin:4px 0;   
}
.carousels .el-carousel__indicator--vertical .el-carousel__button {
    width: 8px !important;
    height: 8px !important;   
    border-radius: 50% !important;
    margin:3px 0;   
}
</style>
